export default __webpack_public_path__ + "static/media/icon-more-circle-solid.9189a465.svg";